<app-loader [isLoading]="isLoading"></app-loader>

<div class="header form-header">
    <div class="top">
        <a routerLink="/home/culture/stories">
            <h3>{{ isEditMode ? 'Cultura Empresarial' : 'Cultura Empresarial' }} /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? (culture.name || 'Editar cultura') : 'Añadir cultura empresarial' }}</h2>
            </div>
        </a>
    </div>
</div>

<form [formGroup]="cultureForm" class="content">
    <h4>Título:</h4>
    <mat-form-field appearance="outline" id="title-form-field" [ngStyle]="{'width': isEditMode ? '30%' : '30%'}">
        <input type="text" matInput placeholder="Título" [formControlName]="isEditMode ? 'name' : 'title'">
        @if (cultureForm.get(isEditMode ? 'name' : 'title')?.invalid && cultureForm.get(isEditMode ? 'name' :
        'title')?.touched) {
        <mat-error>
            El título es requerido
        </mat-error>
        }
    </mat-form-field>

    <div class="dates">
        @if (isEditMode) {
        <button mat-stroked-button class="add-date-button" type="button" (click)="addTab()">
            <span>
                <h4>Añadir pestaña <mat-icon>add</mat-icon></h4>
            </span>
        </button>
        } @else {
        <button mat-button class="add-date-button" type="button" (click)="addTab()">
            <span>
                <h4>Añadir pestaña <mat-icon>add</mat-icon></h4>
            </span>
        </button>
        }
    </div>

    <!-- Tabs section -->
    <div formArrayName="tabs">
        @for (tab of tabs.controls; track tab) {
        <div [formGroupName]="$index" class="tab-container">
            <div class="tab-header">
                <h4>Pestaña {{$index + 1}}:</h4>
                @if (tabs.length > 1) {
                <button mat-icon-button color="warn" type="button" (click)="removeTab(tab)">
                    <mat-icon>delete</mat-icon>
                </button>
                }
            </div>
            <br>

            <!-- Tab title field -->
            <mat-form-field appearance="outline" style="width: 30%;">
                <input type="text" matInput placeholder="Título de la pestaña" formControlName="title">
                @if (tab.get('title')?.invalid && tab.get('title')?.touched) {
                <mat-error>
                    El título de la pestaña es requerido
                </mat-error>
                }
            </mat-form-field>

            <!-- Order field for edit mode -->
            @if (isEditMode) {
            <mat-form-field appearance="outline" style="width: 120px; margin-left: 10px;">
                <mat-label>Orden</mat-label>
                <mat-select formControlName="order">
                    @for (option of orderOptions; track option) {
                    <mat-option [value]="option">{{option}}</mat-option>
                    }
                </mat-select>
                @if (tab.get('order')?.invalid && tab.get('order')?.touched) {
                <mat-error>El orden es requerido</mat-error>
                }
            </mat-form-field>
            }

            <h4>Descripción:</h4>
            <quill-editor formControlName="description" [modules]="modules" [styles]="{height: '300px'}"></quill-editor>
            @if (tab.get('description')?.invalid && tab.get('description')?.touched) {
            <mat-error>
                La descripción es requerida
            </mat-error>
            }

            <br>
            <mat-checkbox formControlName="isHidden">Oculto</mat-checkbox>

            <!-- Existing media display (edit mode only) -->
            @if (isEditMode && culture.tabs && culture.tabs[$index] && culture.tabs[$index].media &&
            culture.tabs[$index].media.length > 0) {
            <div class="existing-media">
                <h4>Archivos existentes:</h4>
                <div class="media-grid">
                    @for (media of culture.tabs[$index].media; track media.id) {
                    <div class="media-item">
                        <img [src]="media.file_url" alt="Media" class="media-preview">
                        <p>{{media.file_url.split('/').pop()}}</p>
                    </div>
                    }
                </div>
                <button mat-button color="warn" type="button" (click)="deleteTabMedia($index)">
                    <mat-icon>delete</mat-icon>
                    Eliminar todos los archivos
                </button>
            </div>
            }

            <h4>Archivos multimedia:</h4>
            <p>Las imágenes deben tener una relación de aspecto de 9:16</p>
            <app-upload-files mode="culture" (filesSelected)="onFilesSelected($index, $event)"
                [validateAspectRatio]="true" [requiredAspectRatio]="0.5625"></app-upload-files>
        </div>
        }
    </div>

    <div class="buttons">
        <button mat-flat-button id="action" type="button" (click)="saveChanges()" [disabled]="isSubmitting">
            @if (isSubmitting) {
            {{ isEditMode ? 'Actualizando...' : 'Guardando...' }}
            } @else {
            {{ isEditMode ? 'Guardar cambios' : 'Guardar cambios' }}
            }
        </button>
        <button mat-flat-button id="cancel" type="button" (click)="cancel()">Cancelar</button>
    </div>
</form>